/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCard/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function TysiaCard({
  children,
  viewPath = "/DesignSystem/TysiaCard",
  className,
  flexGrow,
  flexShrink,
  flexBasis,
  alignSelf,
  width = 740,
  maxWidth,
  height = "auto",
  minHeight,
  maxHeight,
  marginTop,
  marginRight = 0,
  marginBottom = 0,
  marginLeft = 0,
  backgroundColor,
  borderColor,
  borderWidth = 1,
  zoom,
  overflowY,
  size,
  justifyContent = "flex-start",
  alignItems = "stretch",
  flexDirection = "row"
  
}) {
  let isMedia = useIsMedia()
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let marginTopOrdtSpaceS = marginTop ?? dtSpaceS
let backgroundColorOrdtColorsWhite = backgroundColor ?? dtColorsWhite
let borderColorOrdtColorsNeutral400 = borderColor ?? dtColorsNeutral400
  return (<React.Fragment
>
<div
  data-testid="TysiaCard.Vertical"
  data-view-path={viewPath}
 style={{'--fg-1-1bD6tI': flexGrow,'--fs-2-1bD6tI': flexShrink,'--fb-3-1bD6tI': typeof flexBasis === 'number' ? `${flexBasis}%` : flexBasis,'--as-4-1bD6tI': alignSelf,'--h-7-1bD6tI': typeof height === 'number' ? `${height}px` : height,'--mh-8-1bD6tI': typeof minHeight === 'number' ? `${minHeight}px` : minHeight,'--mh-9-1bD6tI': typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight,'--mt-10-1bD6tI': typeof marginTopOrdtSpaceS === 'number' ? `${marginTopOrdtSpaceS}px` : marginTopOrdtSpaceS,'--mr-11-1bD6tI': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-12-1bD6tI': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-13-1bD6tI': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--bblr-14-1bD6tI': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-15-1bD6tI': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-16-1bD6tI': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-17-1bD6tI': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-18-1bD6tI': backgroundColorOrdtColorsWhite,'--bc-19-1bD6tI': borderColorOrdtColorsNeutral400,'--bw-20-1bD6tI': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--z-21-1bD6tI': zoom,'--oy-22-1bD6tI': overflowY,'--w-5-1bD6tI': isMedia.mobile ? "100%" : size === "small" ? "360px" : size === "medium" ? "540px" : size === "large" ? "740px" : size === "xlarge" ? "100%" : size === "custom" ? typeof width === 'number' ? `${width}px` : width : typeof width === 'number' ? `${width}px` : width,'--mw-6-1bD6tI': size === "xlarge" ? "960px" : typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth}}
 className={`views-block ${className} ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 size={size}
 justifyContent={justifyContent}
 alignItems={alignItems}
 flexDirection={flexDirection}
>
{children}
</Children>
</div>
</React.Fragment>)
}